import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';


enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule, {
    providers: [provideCharts(withDefaultRegisterables())],
});
